function _0x37b8() {
  const _0x450940 = [
    "connectedCallback",
    "innerHeight",
    "6967360FvWwow",
    "define",
    "requestAnimationFrame",
    "pageHeight",
    "27856QMJXAW",
    "addEventListener",
    "97uKcFIH",
    "45spTenc",
    "13740xbeGpe",
    "classList",
    "add",
    "12522598fxeaYq",
    "16158bZQdPt",
    "back-to-top",
    "onClick",
    "bind",
    "9678MulUpi",
    "back-to-top--active",
    "1830mbgEmw",
    "2664AKoJaD",
    "checkVisible",
    "touchstart",
    "scrollTo",
    "get",
    "2597707leORQx",
  ];
  _0x37b8 = function () {
    return _0x450940;
  };
  return _0x37b8();
}
const _0x29f87f = _0x15a3;
function _0x15a3(_0x24e48e, _0x5a3741) {
  const _0x37b8b0 = _0x37b8();
  return (
    (_0x15a3 = function (_0x15a363, _0x2ece62) {
      _0x15a363 = _0x15a363 - 0x182;
      let _0xcf09bb = _0x37b8b0[_0x15a363];
      return _0xcf09bb;
    }),
    _0x15a3(_0x24e48e, _0x5a3741)
  );
}
(function (_0x19fbe6, _0x25d02a) {
  const _0x349729 = _0x15a3,
    _0x500bba = _0x19fbe6();
  while (!![]) {
    try {
      const _0x163ca6 =
        (parseInt(_0x349729(0x183)) / 0x1) * (-parseInt(_0x349729(0x189)) / 0x2) +
        (parseInt(_0x349729(0x184)) / 0x3) * (parseInt(_0x349729(0x185)) / 0x4) +
        (parseInt(_0x349729(0x18f)) / 0x5) * (-parseInt(_0x349729(0x18d)) / 0x6) +
        parseInt(_0x349729(0x195)) / 0x7 +
        (parseInt(_0x349729(0x19c)) / 0x8) * (parseInt(_0x349729(0x190)) / 0x9) +
        -parseInt(_0x349729(0x198)) / 0xa +
        parseInt(_0x349729(0x188)) / 0xb;
      if (_0x163ca6 === _0x25d02a) break;
      else _0x500bba["push"](_0x500bba["shift"]());
    } catch (_0x167ec6) {
      _0x500bba["push"](_0x500bba["shift"]());
    }
  }
})(_0x37b8, 0x7f2ff);
if (!customElements[_0x29f87f(0x194)]("back-to-top")) {
  class BackToTop extends HTMLElement {
    constructor() {
      const _0x1a5741 = _0x29f87f;
      super(), (this[_0x1a5741(0x19b)] = window[_0x1a5741(0x197)]);
    }
    [_0x29f87f(0x196)]() {
      const _0x5283d0 = _0x29f87f;
      this["addEventListener"]("click", this[_0x5283d0(0x18b)]),
        this[_0x5283d0(0x182)](_0x5283d0(0x192), this["onClick"], {passive: !![]}),
        window[_0x5283d0(0x182)]("scroll", this[_0x5283d0(0x191)][_0x5283d0(0x18c)](this));
    }
    [_0x29f87f(0x191)](_0x471272) {
      const _0x71b46a = _0x29f87f;
      window[_0x71b46a(0x19a)](() => {
        const _0x5e6039 = _0x71b46a;
        let _0x27cfd6 = window["scrollY"];
        _0x27cfd6 > this[_0x5e6039(0x19b)]
          ? this["classList"][_0x5e6039(0x187)](_0x5e6039(0x18e))
          : this[_0x5e6039(0x186)]["remove"](_0x5e6039(0x18e));
      });
    }
    [_0x29f87f(0x18b)]() {
      const _0x5d34c2 = _0x29f87f;
      window[_0x5d34c2(0x193)]({top: 0x0, left: 0x0, behavior: "smooth"});
    }
  }
  customElements[_0x29f87f(0x199)](_0x29f87f(0x18a), BackToTop);
}
